module.exports = __webpack_public_path__ + "img/msk_tape.6a66efbf.png";